"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OffWorldCityLiving = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const Resources_1 = require("../../Resources");
const MoonExpansion_1 = require("../../moon/MoonExpansion");
const CardRenderer_1 = require("../render/CardRenderer");
const CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
const Card_1 = require("../Card");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const Units_1 = require("../../Units");
const Size_1 = require("../render/Size");
class OffWorldCityLiving extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.OFF_WORLD_CITY_LIVING,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.CITY, Tags_1.Tags.SPACE],
            cost: 35,
            tr: { moonColony: 1 },
            metadata: {
                description: 'Increase your M€ production 1 step per city tile NOT ON MARS. Increase Colony Rate 1 step.',
                cardNumber: 'M53',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => pb.megacredits(1)).nbsp(Size_1.Size.SMALL).slash().city().any.secondaryTag(Tags_1.Tags.SPACE).br;
                    b.moonColonyRate().br;
                    b.vpText('1 VP for every 3 city tiles in play.');
                }),
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.cities(1, 3, true),
            },
        });
    }
    ;
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails, false, true);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return true;
    }
    play(player) {
        const amount = player.game.getCitiesInPlay() - player.game.getCitiesInPlayOnMars();
        player.addProduction(Resources_1.Resources.MEGACREDITS, amount, { log: true });
        MoonExpansion_1.MoonExpansion.raiseColonyRate(player);
        return undefined;
    }
    getVictoryPoints(player) {
        const amount = player.game.getCitiesInPlay();
        return Math.floor(amount / 3);
    }
    getActionDetails(player, card) {
        const bonusMegaCredits = player.cardIsInEffect(CardName_1.CardName.SUITABLE_INFRASTRUCTURE) && player.willGainProductionFromMoonTrackIncrease(this.tr) ? 2 : 0;
        return new RedsPolicy_1.ActionDetails({ card: card, moonColonyRateIncrease: 1, bonusMegaCredits: bonusMegaCredits });
    }
}
exports.OffWorldCityLiving = OffWorldCityLiving;
//# sourceMappingURL=OffWorldCityLiving.js.map